export default {
  name: "Index",
  path: "/index",
  meta: {
    title: "编辑器组件",
  },
};
